import { __write_to_local_storage, __get_from_local_storage } from '../parts/functions';
/*
 * Class for the settings
 */

export class Settings {
    constructor(settings_args) {
        this.volume = null;
        this.fullscreen = false;
        this.autoscroll = false;
        this.__set_volume(settings_args['volume'] ? settings_args['volume'] : 0);

        this.__change_main_volume_listener();
    }

    async __get_fullscreen() {
        return this.fullscreen;
    }

    async __get_autoscroll() {
        return this.autoscroll;
    }

    async __set_autoscroll(autoscroll) {
        if (autoscroll == true) {
            this.autoscroll = true;
        } else {
            this.autoscroll = false;
        }
    }

    async __set_fullscreen(fullscreen) {
        if (fullscreen == true) {
            this.fullscreen = true;
        } else {
            this.fullscreen = false;
        }

        await __write_to_local_storage('fullscreen', this.fullscreen);
    }

    async __get_volume() {
        return this.volume;
    }

    async __set_volume(new_volume) {
        if (parseFloat(new_volume) >= 1) {
            new_volume = 1;
        }
        if (parseFloat(new_volume) <= 0) {
            new_volume = 0;
        }
        this.volume = new_volume;

        await this.__set_volume_for_every_video(this.volume);
        await __write_to_local_storage('volume', this.volume);
    }

    async __set_volume_for_every_video(new_volume) {
        let videos = document.querySelectorAll('video');

        for (let video of videos) {
            video.volume = new_volume;
        }
    }

    async __change_main_volume_listener() {
        let main_volume_input = document.querySelector('.js--main-volume-slider');

        let that = this;

        if (main_volume_input != null) {
            let progress_bar = main_volume_input.nextElementSibling;
            main_volume_input.addEventListener('input', async function (event) {
                // Prevent default event
                event.preventDefault();

                let value = this.value;

                progress_bar.style.width = parseFloat(value) + '%';
                await that.__set_volume(parseFloat(value) / 100);

                $('body')
                    .find('video')
                    .each(async function (index, video) {
                        video.volume = parseFloat(value) / 100;
                    });

                $('body')
                    .find('.js--video-volume-range')
                    .each(async function (index, slider) {
                        $(slider).val(value).trigger('input');
                        $(slider)
                            .siblings()
                            .css('width', parseFloat(value) + '%');
                    });
            });
        }
    }
}
